export default num => Number(num.replace(/,/g, ""));
